import { Controller } from "@hotwired/stimulus"

// Toggles the IP address form between "Single IP" and "IP Range" modes
export default class extends Controller {
  static targets = ["rangeOnly", "individualOnly", "addressLabel", "assetLabel", "typeRadio"]

  connect() {
    this.toggle()
  }

  toggle() {
    const isRange = this.typeRadioTargets.find((radio) => radio.checked)?.value === "range"

    this.rangeOnlyTargets.forEach((element) => {
      element.hidden = !isRange
      this.setInputsDisabled(element, !isRange)
    })

    this.individualOnlyTargets.forEach((element) => {
      element.hidden = isRange
      this.setInputsDisabled(element, isRange)
    })

    if (this.hasAddressLabelTarget) {
      this.addressLabelTarget.textContent = isRange ? "Start IP" : "IP"
    }

    if (this.hasAssetLabelTarget) {
      this.assetLabelTarget.textContent = isRange ? "Managed by:" : "Assigned To:"
    }
  }

  setInputsDisabled(element, disabled) {
    element.querySelectorAll("input, select, textarea").forEach((input) => {
      input.disabled = disabled
    })
  }
}
